export const reasonOptions = [
  { value: "Sales", label: "Sales" },
  { value: "Billing Support", label: "Billing Support" },
  { value: "Tech Support", label: "Tech Support" },
  { value: "Become a dealer", label: "Become an Installer" },
  { value: "Fleet inquiries", label: "Fleet inquiries" },
];
